<template>
    <div>
        <design-2021-apprentice-video-link-player-component
            id="lesson-show-slide-video"
            v-if="slideIn.value"
            :options="options"
            :src="slideIn.value">
        </design-2021-apprentice-video-link-player-component>

        <div
            class="not-found with-header video-slide"
            v-else>
            <div class="icon">
                <i class="fas fa-exclamation-circle"></i>
            </div>
            <div class="alert-notice">{{ $t('lesson.no_video_found') }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-lesson-show-slide-video-component',
    props: ['slideIn'],
    data() {
        return {
            options: {
                responsive: true,
                autoplay: false,
                controls: true,
            },
        };
    },
};
</script>

<style>
#lesson-show-slide-video.video-player {
    margin: 0 auto;
    width: 80% !important;
}
</style>
